import { parseExtendedPath } from "csi/core/extendedPathService";
import ExtendedPath from "csi/core/ExtendedPath";
import { Field } from "csi/def/Field";
import { View } from "csi/def/View";
import Widget from "csi/form/Widget";
import locale from "csi/locale";
import declare from "dojo/_base/declare";

const UserDefaultForm = declare(Widget, {

	onChangeTargetAttributePath(formView: View, field: Field, targetExtendedPath: string, params: object): void {
		this.resetFieldStoreAndValue("TargetAttributeId", "");
	},

	onChangeTargetClass(formView: View, field: Field, targetExtendedPath: string, params: object): void {
		this.resetFieldStoreAndValue("TargetAttributePath", "");
		this.resetFieldStoreAndValue("TargetAttributeId", "");
	},

	onValidateTargetAttributePath(formView: View, field: Field, targetExtendedPath: string, params: object): void {
		if (targetExtendedPath) {
			let ep: ExtendedPath;
			try {
				ep = parseExtendedPath(targetExtendedPath);
			} catch (ex) {
				throw new Error(locale.resource("UserDefaultTargetAttributePathErrorNotValid"));
			}

			const targetType = this.getFieldValue("TargetClass");
			if (ep.getStartType() != targetType) {
				throw new Error(locale.resource("UserDefaultTargetAttributePathErrorWrongStartType"));
			}

			if (!ep.isSingle) {
				throw new Error(locale.resource("UserDefaultTargetAttributePathErrorNotSingle"));
			}
		}
	},
});

export = UserDefaultForm;